// extracted by mini-css-extract-plugin
export default {"addButton":"UserCard_addButton__Wk6y9","userCard":"UserCard_userCard__wgiIe","avatar":"UserCard_avatar__H-Lvt","name":"UserCard_name__FKm8U","modified":"UserCard_modified__qAEa0"};